import { ModelValidation } from "@/models/modelvalidation";

export interface IContentProvider {
    uuid?: string | null;
    businessName?: string | null;
    contactEmail?: string | null;
    note?: string | null;
    demoProvider?: boolean | null;
    status?: string | null;
    id?: string | null;
}

export class ContentProvider extends ModelValidation {

    public uuid!: string | null;
    public businessName!: string | null;
    public contactEmail!: string | null;
    public note!: string | null;
    public demoProvider!: boolean | null;
    public status!: string | null;
    public id!: string | null;

    constructor(contentProvider: IContentProvider | any) {
        super();

        if (!contentProvider) {
            throw new Error("Cannot construct ContentProvider from falsey IContentProvider");
        }

        this.uuid = contentProvider.uuid || null;
        this.businessName = contentProvider.businessName || null;
        this.contactEmail = contentProvider.contactEmail || null;
        this.note = contentProvider.note || null;
        this.demoProvider = contentProvider.demoProvider || null;
        this.status = contentProvider.status || null;
        this.id = contentProvider.id || null;
    }

    public static empty(): ContentProvider {
        return new ContentProvider({});
    }

    public toNewContentProviderDto(): IContentProvider {
        return {
            businessName: this.businessName,
            contactEmail: this.contactEmail,
            note: this.note
        };
    }

    public toUpdateContentProviderDto(): any {
        // these wind up being the same implementation but are semantically different
        const result = this.toNewContentProviderDto();
        result.uuid = this.uuid;
        return result;
    }

    public checkValidation(): any {
        if (
            this.businessName &&
            this.contactEmail
        ) {
            return true;
        } else {
            return false;
        }
    }
}
